<script setup>
import { ref, defineProps, defineEmits } from 'vue';

const props = defineProps({
  visible: Boolean,
  address: String,
  qrImg: String
});

const endpoint = process.env.VUE_APP_PARTNER_PAGE_ENDPOINT
const emit = defineEmits(['close']);
const copied = ref(false);

function close() {
  emit('close');
}

async function copyAddress() {
  if (props.address) {
    await navigator.clipboard.writeText(props.address);
    copied.value = true;
    setTimeout(() => (copied.value = false), 1200);
  }
}
</script>

<template>
  <div v-if="visible" class="custom-swal-popup wallet-popup-overlay" @click.self="close">
    <div class="wallet-popup-content custom-swal-content">
      <button class="wallet-popup-close" @click="close">×</button>
      <div class="custom-swal-title wallet-popup-title">Wallet Address</div>
      <img v-if="!!qrImg" :src="endpoint + qrImg" alt="Wallet QR" class="wallet-popup-qr" />
      <div class="wallet-popup-address-row">
        <span class="wallet-popup-address">{{ address }}</span>
        <button class="wallet-popup-copy" @click="copyAddress">
          <i class="fa-regular fa-copy"></i>
        </button>
      </div>
      <span v-if="copied" class="wallet-popup-copied-msg">Copied!</span>
    </div>
  </div>
</template>
  
<style scoped>
.wallet-popup-overlay {
  position: fixed;
  z-index: 9999;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.wallet-popup-content {
  background: #1a1a1a;
  color: #fff;
  border-radius: 12px;
  padding: 32px 24px 24px 24px;
  min-width: 320px;
  max-width: 90vw;
  box-shadow: 0 4px 24px rgba(0,0,0,0.5);
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.wallet-popup-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 18px;
}

.wallet-popup-qr {
  width: 140px;
  height: 140px;
  margin-bottom: 18px;
  background: #fff;
  border-radius: 8px;
  object-fit: contain;
}

.wallet-popup-address-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  width: 100%;
}

.wallet-popup-address {
  font-family: monospace;
  font-size: 1rem;
  word-break: break-all;
  border-radius: 8px;
  border: 1px solid #fff;
  padding: .2rem .4rem;
  flex: 1;
}

.wallet-popup-copy {
  background: #333;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 4px 12px;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 0.95rem;
}
.wallet-popup-copy:hover {
  background: #4CAF50;
  color: #fff;
}

.wallet-popup-copied-msg {
  display: block;
  color: #4CAF50;
  font-size: 0.92rem;
  margin-top: 2px;
}

.wallet-popup-close {
  position: absolute;
  top: 10px;
  right: 12px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 1.4rem;
  cursor: pointer;
  line-height: 1;
}
</style>